import readiness0 from "./icons/readiness-0.svg";
import readiness10 from "./icons/readiness-10.svg";
import readiness20 from "./icons/readiness-20.svg";
import readiness25 from "./icons/readiness-25.svg";
import readiness30 from "./icons/readiness-30.svg";
import readiness40 from "./icons/readiness-40.svg";
import readiness50 from "./icons/readiness-50.svg";
import readiness60 from "./icons/readiness-60.svg";
import readiness70 from "./icons/readiness-70.svg";
import readiness75 from "./icons/readiness-75.svg";
import readiness80 from "./icons/readiness-80.svg";
import readiness90 from "./icons/readiness-90.svg";
import readiness100 from "./icons/readiness-100.svg";
import readiness110 from "./icons/readiness-110.svg";
import readiness120 from "./icons/readiness-120.svg";
import readiness125 from "./icons/readiness-125.svg";
import readiness130 from "./icons/readiness-130.svg";
import readiness140 from "./icons/readiness-140.svg";
import readiness150 from "./icons/readiness-150.svg";

/** Maps snapped readiness step (0–150) to its Figma-exported SVG asset. */
export const READINESS_CIRCLE_ICONS = {
  0: readiness0,
  10: readiness10,
  20: readiness20,
  25: readiness25,
  30: readiness30,
  40: readiness40,
  50: readiness50,
  60: readiness60,
  70: readiness70,
  75: readiness75,
  80: readiness80,
  90: readiness90,
  100: readiness100,
  110: readiness110,
  120: readiness120,
  125: readiness125,
  130: readiness130,
  140: readiness140,
  150: readiness150,
};
